<template>
  <main v-if="true" :class="{'boxPadding': isBox}">
    <customer-info :loading="false"/>
    <tab-header :current="currentTab"/>
    <div class="tab-content">
      <div class="container-fluid">
        <div class="tab-pane active show">
          <h4 class="text-green mt-5 mb-3">
            日誌紀錄
            <a class="btn btn-default btn-sm m-0" @click="queryOldRecord">查詢舊紀錄</a>
            <a v-if="recordList && recordList.length > 0 && !dataLoading" class="btn btn-default btn-sm m-0 float-right" @click="mergeVisitRecord">合併拜訪記錄</a>
            <!-- <a v-if="isBox"
              :width="iPadWidth"
              class="btn btn-default btn-sm m-0 float-right mr-2" 
              @click="callBoxVisit(data)">排訪</a> -->
            <a v-if="!isBox"
              class="btn btn-default btn-sm m-0 float-right mr-2"
              @click="openScheduledAccess"
              >排訪</a>
          </h4>
          <!-- {{currentYear}} -->
          <div class="record-control row">
            <div class="col-9">
              <carousel
              ref="carousel"
              :value="carouselPage"
              :perPage="8"
              :scrollPerPage="false"
              :paginationEnabled="false"
              :navigationEnabled="true">
                <slide
                v-for="(record, rid) in records"
                :key="`record-item-${rid}`">
                  <button class="item"
                  v-if="!dataLoading"
                  :class="{'active': currentYear == rid}"
                  @click="currentYear=rid; getQueryNote(record.year)">
                    {{ record.year }}
                  </button>
                  <button class="item"
                  v-else
                  :class="{'active': currentYear == rid}">
                    {{ record.year }}
                  </button>
                </slide>
              </carousel>
            </div>
            <div class="col-3">
              <form class="form search-container">
                <div class="form-group">
                  <input type="text" v-model="recodrdKeyowrd" class="form-control" placeholder="輸入關鍵字" maxlength="50" @input="checkRecodrdKeyowrd" @blur="checkRecodrdKeyowrd" />
                  <button @click.prevent="doSearch" class="btn btn-icon btn-text m-0">
                    <i class="icon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="record-container" v-if="recordList && recordList.length > 0 && !dataLoading">
            <div class="record-item"
            v-for="(record, i) in recordList"
            :key="`event-${i}`">
            <!-- {{record}} -->
              <div class="record-table">
                <table class="table insurance-green">
                  <tr v-if="record.isNote=='Y'">
                    <th width="100">{{record.EVENT_DATE}}<br>{{record.EVENT_TIME}}</th>
                    <th width="100">私人筆記</th>
                    <td>
                      <div class="note-string" v-html="highlight(record.NOTE_STRING_FORMAT)"></div>
                    </td>
                  </tr>
                  <tr v-else>
                    <th rowspan="2" width="100">{{record.EVENT_DATE}}<br>({{record.DAY_OF_WEEK}})<br>{{record.EVENT_TIME}}</th>
                    <th width="100">私人筆記</th>
                    <td>
                      <div class="content empty" v-if="!record.NOTE_STRING || record.NOTE_STRING===''">您尚未填寫私人筆記</div>
                      <div class="note-string" v-else v-html="highlight(record.NOTE_STRING_FORMAT)"></div>
                    </td>
                  </tr>
                  <tr v-if="record.isNote!='Y'">
                    <th>活動日誌</th>
                    <td>
                      <div class="content empty" v-if="record.RECORD_STRING==='' &&  record.currentIndex===''">
                        您尚未填寫拜訪紀錄
                      </div>
                      <div class="content" v-else>
                        <p style="font-size: 20px;font-weight: 600;word-break: break-all;" class="note-string" v-html="highlight(record.RECORD_STRING)"></p>
                        <div class="list badgets">
                          <!-- {{record.SUB_CLS_CODE}} -->
                          <div class="badget gray item"
                          v-for="(tag,j) in getTagName(record.SUB_CLS_CODE)"
                          :key="`record-${i}-tag-${j}`" v-html="highlight(tag)">
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="record-action text-right">
                <!-- 編輯按鈕 -->
                <a class="btn btn-default btn-icon btn-sm my-0" @click="editRecord(record)">
                  <i class="icon-edit"></i>
                </a>
                <br/>
                <!-- 刪除按紐 -->
                <!-- <a class="btn btn-red btn-icon btn-sm" @click="confirmRemoveRecord(record, i)">
                  <i class="icon-trashcan"></i>
                </a> -->
              </div>
            </div>

          </div>
          <div class="empty-block" v-else>
            <span v-if="dataLoading"><div class="section-loading d-inline-block" style="height:20px; width:30px"></div> 資料讀取中 . . .</span> 
            <span v-else-if="recordOrigin.length > 0">找不到符合的資料，建議換其他關鍵字進行搜尋</span>
            <span v-else>尚未有任何已完成的拜訪</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <new-record-modal
    :open="newRecordModalOpen"
    :record="currentRecord"
    @close="panelClose('newRecordModalOpen')"
    @delete="confirmCheck"
    @submit="submitNewRecord"/>

    <warning-modal
    :open="warningModalOpen"
    :message="warningMessage"
    @close="panelClose('warningModalOpen')"
    @submit="removeRecord" />

    <visit-modal
    :open="visitModalOpen"
    :visit_data="visit_data"
    :isLoading="isViditDataLoading"
    @close="panelClose('visitModalOpen')"/>

    <!-- 排訪 -->
    <scheduled-access
    :open="ScheduledAccessModalOpen"
    :record="visit_custData"
    :cat-info="categoryInfo"
    @close="panelClose('ScheduledAccessModalOpen')"
    @submit="submitScheduledAccess"
    />

    <!--修改私人筆記-->
    <note-modal
      :open="noteModalOpen"
      :record="currentRecord"
      @close="panelClose('noteModalOpen')"
      @submit="updatePersonalNote"
    />

    <!-- 合併拜訪記錄視窗 -->
    <merge-visit-modal
      :open="mergeVisitModalOpen"
      :csid="$store.state.custInfo.serNo"
      @close="panelClose('mergeVisitModalOpen')"
      @submit="mergeVisitFinish"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import { commonMixin } from '../../mixins/common';
import { getNote } from '../../service';
import { addNote } from '../../service';
import { updateNote } from '../../service';
import { queryNoteList } from '../../service'
import { editVisitRecord } from '../../service'
import { deleteVisitEvent } from '../../service'
import { queryOldCRMRecord } from '../../service'
import { updatePersonalNote } from '../../service'

import Avatar from '../../components/Avatar';
import CustomerInfo from '../components/CustomerDetail/CustomerInfo';
import TabHeader from '../components/CustomerDetail/TabHeader';
import VisitModal from '../components/VisitModal';

import WarningModal from '../components/WarningModal';
import NewRecordModal from '../components/NewRecordModal';
import NoteModal from '@/desktop/components/NoteModal';
import MergeVisitModal from '@/desktop/components/MergeVisitModal';
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";

let const_visit_data = [
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  },
  {
    visit_date: '108/10/10',
    visit_title: '了解家庭財務跟主要決定者',
    visit_content: '簽收保單',
  }
]

export default {
  name: 'CustomerDetail3',
  mixins: [commonMixin],
  data () {
    return {
      isSearch: false,
      warningMessage: '',
      currentRecord: null,
      dataLoading: true,
      newRecordModalOpen: false,
      records: [],
      recordList: [],
      recordOrigin: [],
      currentYear: 0,
      carouselRendered: false,
      carouselPage: 0,
      recodrdKeyowrd: '',
      currentTab: 0,
      noteEdit: false,
      warningModalOpen: false,
      currentDelIndex: 0,
      noteIsNewEdit: true,
      note: null,
      visitModalOpen: false,
      selectedVisitInstance: null,
      visit_data: [],
      isViditDataLoading: false,
      noteModalOpen: false,
      mergeVisitModalOpen: false, //合併拜訪視窗
      ScheduledAccessModalOpen: false,
      visit_custData: {},
      categoryInfo: {
        category_name: ''
      },
    }
  },
  components: { 
    Avatar, CustomerInfo, TabHeader, 
    // basic component
    Carousel, Slide, WarningModal, NewRecordModal, VisitModal, NoteModal, MergeVisitModal, ScheduledAccess
  },
  computed: {
    ...mapGetters(['BaseUrl', 'UserInfo']),
    searchResult () {
      if(!this.recodrdKeyowrd.length) return []

      let result = this.customer.record.reduce((array, year, index) => {
        year.data.forEach(record => {
          let hasKeyword = false
          for(var i in record) {
            if (typeof record[i]=='string') {
              if (record[i].indexOf(this.recodrdKeyowrd) > -1) hasKeyword  =true
            } else if (typeof record[i]==='object') {
              if (record[i].findIndex(o => o.indexOf(this.recodrdKeyowrd)>-1) > -1) hasKeyword  =true
            }
          }
          if(hasKeyword) {
            array.push(record)
          }
        })

        return array
      }, [])

      return result
    },
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === 'box';
    }
  },
  watch: {
    "$route": function() {
      this.initCustomerDetail3()
    }
  },
  methods: {
    //檢查輸入欄位
    checkRecodrdKeyowrd(){
      this.recodrdKeyowrd = this.recodrdKeyowrd.replace(/[<>!@#$^&,."'?%;_()+-/{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.recodrdKeyowrd, false, 50) > 50) {
        this.recodrdKeyowrd = this.recodrdKeyowrd.substring(0, this.stringBytes(this.recodrdKeyowrd, true ,50));
      }
    },
    ...mapActions([
      'setPageLock', "setListAreaSerNo"
    ]),
    doSearch () {  //  關鍵字搜尋內容
      this.recordList = this.recordOrigin.filter(item => {
        const subCode = item.SUB_CLS_CODE.split(',').map(item => {return item.substr(5)}).join('')
        if(item.NOTE_STRING.includes(this.recodrdKeyowrd) || item.RECORD_STRING.includes(this.recodrdKeyowrd) || subCode.includes(this.recodrdKeyowrd)) {
          return true
        }
      })
    },
    highlight (word) {
      if(this.recodrdKeyowrd !== '') {
        return word.replace(new RegExp(this.recodrdKeyowrd + '(?!([^<]+)?<)', 'gi'), '<b style="color:#F58818;">$&</b>')
      } else {
        return word
      }

    },
    editRecord (record) {
      this.currentRecord = record
      if(record.isNote && record.isNote == "Y") {
        this.panelOpen('noteModalOpen')
      } else {
        this.panelOpen('newRecordModalOpen')
      }
    },
    // confirmRemoveRecord (record, i) {
    //   this.currentDelIndex = i
    //   this.currentRecord = record
    //   this.warningMessage = `您是否確認要刪除 ${this.$store.state.custInfo.name} 於 ${record.EVENT_DATE} 的拜訪記錄？`
    //   this.panelOpen('warningModalOpen')
    // },
    removeRecord () {
      this.panelClose('warningModalOpen')
      this.dataLoading = true

      let reportData = {
        input_id: this.$store.state.userInfo.id,  // 業務員ID
				str_date: this.convertROCtoAD(this.currentRecord.EVENT_DATE),  // 拜訪開始日
				str_time: this.formatTimeToHHMMSS(this.currentRecord.EVENT_TIME),  // 拜訪開始時間
        event_ser_no: this.currentRecord.EVENT_SER_NO,	 // 事件序號
        event_year: this.currentRecord.EVENT_YEAR,  // 事件年份
      }

      deleteVisitEvent(this.$store.state.userInfo.id, reportData).then(result => {
        this.Loading = false
        if(result.header && result.header.status == '200'){
          this.setToastMsg(result.header.message)
          let is_done = 'N'
          let rocyear = this.records[this.currentYear].year
          queryNoteList(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), is_done, rocyear).then(result =>{
            if(result.header && result.header.status == '200'){
              this.recordList = this.formatRecordList(result.body.detail);
              this.recordOrigin = [...this.recordList];
            }else{
              console.error('查詢紀錄簿連線異常')
            }
            this.dataLoading = false
          })
        } else {
          this.setToastMsg(result.header.message)
        }
      })
      this.panelClose('newRecordModalOpen')
    },
    // format yyy/MM/dd to yyyy-MM-dd
    convertROCtoAD(rocDateStr) {
      const parts = rocDateStr.split('/');
      if (parts.length !== 3) return null;

      const rocYear = parseInt(parts[0], 10);
      const year = rocYear + 1911;
      const month = parts[1].padStart(2, '0');
      const day = parts[2].padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    // format HH:mm to HH:mm:ss
    formatTimeToHHMMSS(timeStr) {
      const parts = timeStr.split(':');
      if (parts.length === 2) {
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:00`;
      } else if (parts.length === 3) {
        return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
      }
      return null; // 格式錯誤
    },
    confirmCheck(){
      this.warningMessage = '您確定要刪除<span class="text-red font-weight-bold">此排訪事件嗎？</span>'
      this.panelOpen("warningModalOpen")
    },
    submitNewRecord (recordInfo, form, selectOpt) {  // 編輯拜訪紀錄
      this.dataLoading = true
      editVisitRecord(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), recordInfo, form, selectOpt).then(result => {
        if(result.header && result.header.status === '200'){
          this.$toast.info({title: result.header.message})
          let is_done = 'N'
          let rocyear = this.records[this.currentYear].year
          // refresh page
          queryNoteList(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), is_done, rocyear).then(result =>{
            if(result.header && result.header.status == '200'){
              this.recordList = this.formatRecordList(result.body.detail);
              this.recordOrigin = [...this.recordList];
            }else{
              console.error('查詢紀錄簿連線異常')
            }
            this.dataLoading = false
          })
        }else{
          console.error('編輯拜訪紀錄 API 錯誤')
        }
      })
      this.panelClose('newRecordModalOpen')
    },
    openScheduledAccess() {
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      this.init();
    },
    editNewNote() {
      this.note = {
        noteContent: ''
      }
      this.noteEdit = true
    },
    insertOrUpdateNote() {
      this.noteEdit = false
      if(this.noteIsNewEdit) {
        addNote(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), this.note.noteContent).then(result => {
          if(result.header && result.header.status === '200'){
            this.getRemoteNote()
          }else{
            this.$toast.info({title: result.header.message})
          }
        })
      } else {
        updateNote(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), this.note.noteContent, this.note.date, this.note.time)
      }
    },
    getRemoteNote() {
      getNote(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo)).then(result => {
        if(result.header && result.header.status === '200'){
          if(result.body.detail && result.body.detail.length > 0) {
            let detail = result.body.detail
            detail.sort((a, b) => {
              return a.NOTE_TIME > b.NOTE_TIME ? 1 : -1
            })
            detail.sort((a, b) => {
              return a.NOTE_DATE < b.NOTE_DATE ? 1 : -1
            })
            this.noteIsNewEdit = false
            this.note = {
              noteContent: detail[0].NOTE_STRING,
              date: detail[0].NOTE_DATE,
              time: detail[0].NOTE_TIME
            }
          } else {
            this.noteIsNewEdit = true
            this.note = null
          }
        }else{
          this.$toast.info({title: '連線逾時'})
        }
      })
    },
    initCustomerDetail3() {
      this.getRemoteNote()
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    },
    getTagName(val){
      if(!val){
        return []
      }
      let newVal = []
      let aryData = val.split(',').map(item => {
        return item.substr(5) 
      })
      newVal.push(aryData);
      return newVal[0]
    },
    getQueryNote(rocyear){
      let is_done = 'N'
      let rec = this.records
      let $this = this
      this.dataLoading = true
      queryNoteList(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), is_done, rocyear).then(result =>{
        if(result.header && result.header.status == '200'){
          this.recordList = this.formatRecordList(result.body.detail);
          this.recordOrigin = [...this.recordList];
        }else{
          console.error('查詢紀錄簿連線異常')
        }
        
        for(let i=0;i<rec.length;i++){
          if(rec[i].year == rocyear){
            $this.$set($this.records[i], "data" , result.body.detail)
          }
        }
        this.$forceUpdate()
        this.dataLoading = false
      })
    },
    queryOldRecord() {
      this.isViditDataLoading = true
      this.visit_data = []
      this.panelOpen('visitModalOpen')
      queryOldCRMRecord(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo)).then(result =>{
        if(result.header && result.header.status == '200'){
          this.visit_data = result.body.map(map =>{ 
            return {
              visit_day: map.visit_day,
              csitema: map.csitema.split(',') || [],
              csitemb: map.csitemb.split(',') || [],
              csitemc: map.csitemc.split(',') || [],
              csitemd: map.csitemd || '',
              coalesce: map.coalesce || '',
              state: map.state
            }
          })
        }
        else{
          if(result.header && result.header.message) {
            this.$toast.info({title:result.header.message})
          } else {
            this.$toast.info({title: '連線異常,請稍候再操作'})
          }
          this.panelClose('visitModalOpen')
        }
        this.isViditDataLoading = false
      })
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    },
    //修改私人筆記
    updatePersonalNote(noteDate, noteTime, note) {
      this.dataLoading = true;
      updatePersonalNote(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo,
        noteDate,
        noteTime,
        note
      ).then(result => {
        if (result.header && result.header.status === "200" && result.body.result) {
          this.$toast.info({ title: "更新成功" });
          // 重新查詢
          queryNoteList(
            this.$store.state.userInfo.id,
            this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo,
            "N",
            this.records[this.currentYear].year
          ).then(result => {
            if (result.header && result.header.status == "200") {
              this.recordList = this.formatRecordList(result.body.detail);
              this.recordOrigin = [...this.recordList];
            } else {
              console.error("查詢紀錄簿連線異常");
            }
            this.dataLoading = false;
          });
        } else {
          this.dataLoading = false;
          this.$toast.info({ title: "修改私人筆記 API 錯誤" });
        }
      });
      this.panelClose("noteModalOpen");
    },
    //產生超連結內容
    createHyperLinkTag(str) {
      let secondIndex = str.indexOf(",");
      let thirdIndex = str.indexOf(">");
      let title = str.substring(1, secondIndex);
      let url = str.substring(secondIndex + 1, thirdIndex);
      return "<a href = '" + url + "' target='_blank'>" + title + "</a>";
    },
    //格式化筆記內容
    formatNoteContent(val) {
      let replaceArray = [];
      let subString = val;
      while (subString.match(/<.*?,.*?>/)) {
        let matchStr = subString.match(/<.*?,.*?>/)[0];
        replaceArray.push({
          before: matchStr,
          after: this.createHyperLinkTag(matchStr),
        });
        subString = subString.substring(subString.indexOf(matchStr) + matchStr.length, subString.length);
      }
      replaceArray.forEach((item) => {
        val = val.replace(item.before, item.after);
      });
      return val;
    },
    //回傳活動日誌&私人筆記
    formatRecordList(list) {
      return list.map(item => {
        return {
          EVENT_DATE: item.EVENT_DATE || "",
          EVENT_SER_NO: item.EVENT_SER_NO || "",
          EVENT_TIME: item.EVENT_TIME || "",
          EVENT_YEAR: item.EVENT_YEAR || "",
          DAY_OF_WEEK: item.DAY_OF_WEEK || "",
          ISDONE: item.ISDONE || "",
          ISMISS: item.ISMISS || "",
          NOTE_STRING: item.NOTE_STRING,
          NOTE_STRING_FORMAT: this.formatNoteContent(item.NOTE_STRING) || "",
          RECORD_STRING: item.RECORD_STRING || "",
          RECORD_SYMBOL: item.RECORD_SYMBOL || "",
          REFERRAL1: item.REFERRAL1 || "",
          REFERRAL2: item.REFERRAL2 || "",
          SUB_CLS_CODE: item.SUB_CLS_CODE || "",
          isNote: item.isNote || "",
          NOTE_DATE: item.NOTE_DATE || "",
          NOTE_TIME: item.NOTE_TIME || ""
        };
      });
    },
    //開啟合併拜訪記錄視窗
    mergeVisitRecord() {
      this.panelOpen("mergeVisitModalOpen");
    },
    //合併拜訪記錄完成
    mergeVisitFinish(msg) {
      this.panelClose("mergeVisitModalOpen");
      this.setToastMsg(msg);
      // 重新查詢
      this.dataLoading = true;
      queryNoteList(
        this.$store.state.userInfo.id,
        this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo,
        "N",
        this.records[this.currentYear].year
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.recordList = this.formatRecordList(result.body.detail);
          this.recordOrigin = [...this.recordList];
        } else {
          console.error("查詢紀錄簿連線異常");
        }
        this.dataLoading = false;
      });
    },
    init(){
      let is_done = 'N'
      let rocyear = this.records[this.currentYear].year
      let rec = this.records
      let $this = this
      this.dataLoading = true
      queryNoteList(this.$store.state.userInfo.id, (this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo), is_done, rocyear).then(result =>{
        if(result.header && result.header.status == '200'){
          this.recordList = this.formatRecordList(result.body.detail);
          this.recordOrigin = [...this.recordList];
        }else{
          console.error('查詢紀錄簿連線異常')
        }

        // 金寶版本
        for(let i=0;i<rec.length;i++){
          if($this.records[i].year == rocyear){
            $this.$set($this.records[i], "data" , result.body.detail)
          }
        }

        this.$forceUpdate()

        this.dataLoading = false
      })

      this.setListAreaSerNo("") // 拜訪紀錄，serno預設為空字串

      //init visit_custData 開啟排訪 初始化需用參數
      this.visit_custData.visit = {}
      this.visit_custData.id = this.$store.state.custInfo.ID || this.$store.state.custInfo.serNo
      this.visit_custData.name = this.$store.state.custInfo.name

      setTimeout(() => {
        this.carouselPage = this.$refs.carousel.pageCount
        this.carouselRendered = true
        this.currentYear = this.records.length -1
      })
    },
  },
  beforeMount () {
    let routeNumber = (this.$route.name.split(/-/g)).reverse()
    this.currentTab = Number(routeNumber[0])
    let d = new Date()
    let yearLength = 10
    let currentYear = d.getFullYear() - (1911 + yearLength -1)
    for(let i= 0;i<yearLength; i++){
      this.records[i] = {
        year: currentYear + i,
        data:[]
      }
    }
    this.currentYear = this.records.length - 1
  },
  async mounted () {
    this.init()
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
.note-string {
  white-space: pre-wrap;
}
.float-right {
  float: right;
}
</style>
